import { Link } from "react-router-dom";

export const Logo = ({ to = "/", small = false }) => (
  <Link to={to} className="group inline-flex items-center gap-2.5" data-testid="brand-logo-link">
    <span className="relative grid h-7 w-7 place-items-center bg-blue-600">
      <span className="h-2.5 w-2.5 bg-white group-hover:rotate-45" style={{ transition: "transform 300ms ease-out" }} />
      <span className="absolute -right-1 -top-1 h-2 w-2 bg-cyan-400" />
    </span>
    {!small && <span className="font-display text-lg font-extrabold tracking-tight text-white">HackLabs</span>}
  </Link>
);
